import React from 'react'; // Make sure to import your image
import { FaCheckCircle, FaReact, FaNodeJs, FaServer, FaDatabase, FaPaintBrush, FaNetworkWired } from 'react-icons/fa'; // Import necessary icons
import uiuximg from "../assets/img/uiux.png"; // Import your UI/UX image

const data = [
  {
    type: 'ECommerce Web App',
    functionalities: 'Product listing, shopping cart, payment gateways, user accounts',
    example: 'Amazon, Shopify',
    costEstimate: '$50,000 to $300,000+',
  },
  {
    type: 'Social Media Platform',
    functionalities: 'User profiles, news feed, messaging, content sharing',
    example: 'Facebook, Instagram',
    costEstimate: '$60,000 to $250,000+',
  },
  {
    type: 'Content Management System (CMS)',
    functionalities: 'Content creation, publishing, user management',
    example: 'WordPress, Joomla',
    costEstimate: '$30,000 to $100,000+',
  },
  {
    type: 'Marketplace',
    functionalities: 'Search, listing, user profiles, payment system',
    example: 'Airbnb, Etsy',
    costEstimate: '$80,000 to $400,000+',
  },
  {
    type: 'Static Web App',
    functionalities: 'Fixed content, simple structure',
    example: 'Portfolio sites',
    costEstimate: '$20,000 to $60,000',
  },
  {
    type: 'Enterprise Web App',
    functionalities: 'CRM, data management, analytics, collaboration tools',
    example: 'Salesforce, SAP',
    costEstimate: '$100,000 to $500,000+',
  },
  {
    type: 'Healthcare Web App',
    functionalities: 'Patient record keeping, appointment scheduling, telemedicine',
    example: 'WebMD, Doctor On Demand',
    costEstimate: '$50,000 to $300,000+',
  },
  {
    type: 'eLearning Web App',
    functionalities: 'Online courses, progress tracking, virtual classes',
    example: 'Coursera, Udemy',
    costEstimate: '$30,000 to $200,000+',
  },
];

const UiUxDevelopmentPage = () => {
  return (
    <section className="py-16 px-10 bg-white">
      <div className="container mx-auto">
        <h1 className="text-4xl font-bold text-gray-800 text-center mb-12">UI/UX Development</h1>
        
        <div className="flex flex-col md:flex-row">
          {/* Left Column */}
          <div className="md:w-1/2 md:pr-4 mb-8">
            <h2 className="text-2xl font-semibold mb-4">About UI/UX Development</h2>
            <p className="text-gray-700 mb-4">
              Our UI/UX development services focus on creating user-centric designs that enhance user experience and engagement. 
              We utilize industry best practices to ensure that our solutions are not only visually appealing but also functional and intuitive.
            </p>
            <h3 className="text-lg font-semibold mb-2">Services We Offer:</h3>
            <ul className="list-disc list-inside mb-4">
              <li className="flex items-center mb-2">
                <FaCheckCircle className="text-green-500 mr-2" />
                User Research and Analysis
              </li>
              <li className="flex items-center mb-2">
                <FaCheckCircle className="text-green-500 mr-2" />
                Wireframing and Prototyping
              </li>
              <li className="flex items-center mb-2">
                <FaCheckCircle className="text-green-500 mr-2" />
                User Interface Design
              </li>
              <li className="flex items-center mb-2">
                <FaCheckCircle className="text-green-500 mr-2" />
                Usability Testing
              </li>
            </ul>
          </div>

          {/* Right Column */}
          <div className="md:w-1/2 md:pl-4 mb-8">
            <img src={uiuximg} alt="Web Development Services" className="rounded-lg shadow-lg" />
          </div>
        </div>

        {/* Pricing Table */}
        <h2 className="text-2xl font-semibold text-center my-8 underline">Our Pricing</h2>
        <div className="overflow-x-auto px-20 pt-5">
          <table className="min-w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200 text-gray-600">
                <th className="border border-gray-300 px-4 py-2">Type</th>
                <th className="border border-gray-300 px-4 py-2">Functionalities</th>
                <th className="border border-gray-300 px-4 py-2">Example</th>
                <th className="border border-gray-300 px-4 py-2">Cost Estimate</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-white">
                  <td className="border border-gray-300 px-4 py-2">{item.type}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.functionalities}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.example}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.costEstimate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Technology Section */}
        <h2 className="text-2xl font-semibold text-center my-8">Technology We Use</h2>
        <p className="text-gray-700 text-center mb-4">
          We leverage cutting-edge technologies to deliver high-quality web solutions.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 my-8 mx-auto max-w-4xl">
          {/* Technology Cards */}
          {[
            { iconClass: "fab fa-react text-blue-500", title: "React", description: "A JavaScript library for building user interfaces." },
            { iconClass: "fab fa-node text-green-500", title: "Node.js", description: "JavaScript runtime for server-side development." },
            { iconClass: "fas fa-server text-gray-700", title: "Express", description: "Fast, minimal web framework for Node.js." },
            { iconClass: "fas fa-database text-green-600", title: "MongoDB", description: "A NoSQL database for modern applications." },
            { iconClass: "fas fa-paint-brush text-indigo-500", title: "Tailwind CSS", description: "A utility-first CSS framework for rapid UI development." },
            { iconClass: "fas fa-network-wired text-blue-500", title: "RESTful APIs", description: "Architectural style for scalable web services." },
          ].map((tech, idx) => (
            <div key={idx} className="bg-white shadow-lg p-6 rounded-lg text-center">
              <i className={`${tech.iconClass} text-5xl mb-4`}></i>
              <h3 className="text-xl font-semibold mb-2">{tech.title}</h3>
              <p className="text-gray-600">{tech.description}</p>
            </div>
          ))}
        </div>

        {/* Development Process Section */}
        <h2 className="text-2xl font-semibold text-center my-8">Understand the Development Process</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-gray-700 text-center mb-8 max-w-5xl mx-auto">
          {[
            { iconClass: "fas fa-pencil-ruler text-blue-500", title: "01. Design and Planning", description: "Understand your vision, create a detailed plan, and develop wireframes." },
            { iconClass: "fas fa-laptop-code text-green-500", title: "02. Development and Testing", description: "Build the app using the latest technologies and perform rigorous testing." },
            { iconClass: "fas fa-rocket text-red-500", title: "03. Launch & Support", description: "Deploy the app to stores and provide ongoing updates and maintenance." },
          ].map((step, idx) => (
            <div key={idx} className="bg-white shadow-lg p-6 rounded-lg transform transition-all duration-500 hover:scale-105 hover:shadow-2xl animate-fade-in-up">
              <i className={`${step.iconClass} text-5xl mb-4`}></i>
              <h3 className="text-lg font-semibold mb-2">{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>

        
      </div>
    </section>
  );
};

export default UiUxDevelopmentPage;

